import { makeStyles } from '@material-ui/core/styles';


export default makeStyles(theme => ({
    card: {
        // height: "150px",
        // border: '2px solid #0049A3',
        // filter: 'dropShadow(0px 0px 10px #4D80C9)',
        // borderRadius: '10px',
        height: '152px',
        width: '286px',
        borderRadius: '18px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#FFFFFF',
        border: '1px solid #D9D9D9',
    },
}));
